import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgPrint} from "~/assets/svg/print.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmPrintIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgPrint id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
